import React from "react";


const SectionCard = ({
    title,
    subtitle,
    action,
    children,
    className = "",
}) => {

    return (

        <section
            className={
                `dashboard-section-card ${className}`
            }
        >

            <div
                className="dashboard-section-header"
            >

                <div>

                    <h3>
                        {title}
                    </h3>


                    {
                        subtitle && (

                            <p>
                                {subtitle}
                            </p>
                        )
                    }

                </div>


                {
                    action && (

                        <div
                            className="dashboard-section-action"
                        >
                            {action}
                        </div>
                    )
                }

            </div>


            <div
                className="dashboard-section-body"
            >
                {children}
            </div>

        </section>
    );
};


export default SectionCard;